window.save = (message) =>
  window.dispatchEvent(
    new CustomEvent('save', {
      key: message,
    })
  )

function encodeQueryString(data) {
  const ret = []
  Object.entries(data).forEach(([key, value]) => {
    if (value === undefined || value === null) return
    ret.push(encodeURIComponent(key) + '=' + encodeURIComponent(value))
  })
  return '?' + ret.join('&')
}

function characterObject() {
  return {
    data: {
      tag: '',
      character: '',
      previewImage: '',
      label: '',
      edit: false,
      existing_character_count: 1,
    },
    character: {},
    loading: false,
    init(key, tag, character) {
      if (character != undefined) this.character = JSON.parse(character)

      this.data.tag = tag
      this.data.character = key
      this.data.label = this.character.label
      this.data.existing_character_count = characterStorage.getAllCharacters()
        ? characterStorage.getAllCharacters().length
        : 1
      this.updatePreview()
    },
    async edit(key) {
      
      // console.log('product-config 28 - editing character: ', key)
      
      this.loading = true
      // Get character from session storage using key given
      let characterToEdit = JSON.parse(sessionStorage.getItem(key))

      // console.table(characterToEdit)
      
      // let builderUrl = `${globalMoonshineBaseUrl}/${characterToEdit.brand}/?key=${key}&tag=${this.data.tag}`
      let queryData = { key, tag: this.data.tag }
      let builderUrl = `${globalMoonshineBaseUrl}/${
        characterToEdit.brand
      }${encodeQueryString(queryData)}`
      
      console.log('builderUrl: ', builderUrl)
      
      document
        .getElementById('builder')
        .contentWindow.location.replace(builderUrl)
      //load character
      //               var loadedCharacterImage = "".concat('https://builder.midnightplatform.net/midnight/system/generate/').concat(characterToEdit.character, ".png");

      //               window.preview(loadedCharacterImage)

      // TODO: Remove delay and make sure nothing breaks (AH)
      // MT: this value is large due to the extra second added to the builder initialiser function
      // without it - the load character func will be over-written by the original character
      await new Promise((r) => setTimeout(r, 2500))
      this.loading = false
      var contentWindow = document.getElementById('builder').contentWindow
      // NOTE:#7 Load character in builder
      contentWindow.postMessage(
        {
          event: 'load',
          key: 'character',
          value: characterToEdit.character,
        },
        '*'
      )

      let builderWindow = document.getElementById('builder').contentWindow
      builderWindow.postMessage({ event: 'navigate', key: 'builder' }, '*')
      window.windowScrollPosition = $(window).scrollTop()
      // document.scrollingElement.scrollTop = 0
      $('html, body').addClass('noScroll')
      toggleBuilderWindow('flex')
      $('.breadcrumbs').css('z-index', 1)
      $('.site-header').css('z-index', 1)
      $('body').css('height', '100%')
      $('body').css('overflow', 'hidden')
    },
    async create(key, tag) {
      let queryData = { key, tag }
      let builderUrl = `${globalMoonshineBaseUrl}${encodeQueryString(
        queryData
      )}`

      document
        .getElementById('builder')
        .contentWindow.location.replace(builderUrl)

      console.log(builderUrl);
      
      let builderWindow = document.getElementById('builder').contentWindow
      await new Promise((r) => setTimeout(r, 250))
      window.windowScrollPosition = $(window).scrollTop()
      // document.scrollingElement.scrollTop = 0
      $('html, body').addClass('noScroll')
      toggleBuilderWindow('flex')
      $('.breadcrumbs').css('z-index', 1)
      $('.site-header').css('z-index', 1)
      $('body').css('height', '100%')
      $('body').css('overflow', 'hidden')
    },
    async loadCharacter(key) {
      let config = characterStorage.getMoonshineConfig()
      // let config = document.getElementById('moonshine_config_json')
      // config = JSON.parse(config ? config.innerHTML : null)

      // let url = `${globalMoonshineBaseUrl}/?screen=selector&key=${key}&tag=${this.tag}`
      let queryData = { screen: 'selector', key, tag: this.data.tag }
      let builderUrl = `${globalMoonshineBaseUrl}${encodeQueryString(
        queryData
      )}`
      // console.log('product-config.js 86 - url:', url)
      document
        .getElementById('builder')
        .contentWindow.location.replace(builderUrl)

      await new Promise((r) => setTimeout(r, 2500))
      let characters = characterStorage.getAllCharacters()

      let contentWindow = document.getElementById('builder').contentWindow

      // console.log('🚀 product-config.js 93 - sending characters', characters)
      contentWindow.postMessage(
        {
          event: 'characters',
          value: characters,
        },
        '*'
      )

      window.windowScrollPosition = $(window).scrollTop()
      // document.scrollingElement.scrollTop = 0
      $('html, body').addClass('noScroll')
      toggleBuilderWindow('flex')
      $('.breadcrumbs').css('z-index', 1)
      $('.site-header').css('z-index', 1)
      $('body').css('height', '100%')
      $('body').css('overflow', 'hidden')

      //trackAnalytics('Product Page', 'Opened Character List')
    },
    updatePreview(preview) {
      if (preview) {
        // If preview is provided set it and return
        // console.log('📞 - product-config.liquid - updatePreview', preview)
        this.data.previewImage = preview
        return preview
      }

      // console.log(
      //   '😃 - product-config.liquid - line 123 - character:',
      //   this.data.character
      // )
      // Get character imageUrl using the character identifier
      let image = window.store
        ? window.store.get(this.data.character)
        : undefined

      //let image = window.store?.get(this.data.character)
      if (image) {
        this.data.edit = true
      }
      if (!image) {
        //image = 'https://moonshine-live.midnightplatform.net/' + window.store?.get('brand') + '_ghost.png'

        // this line is causing the issue - not 100% why, the call to window.store.get if window.store is undefined
        // causes the weird multi-character-block bug
        // guess it's something to do with how Alpine.js renders it ?
        // have to get the brand someother way...

        let productConfig = document.getElementById('moonshine_config_json')
          ? JSON.parse(
              document.getElementById('moonshine_config_json').innerHTML
            )
          : null
        let brand = productConfig.brand
        if (!brand) {
          image =
            'https://cdn.shopify.com/s/files/1/0167/0217/7380/t/20/assets/undefined_ghost.png?v=12608125828289829475'
        } else {
          image =
            'https://moonshine-live.midnightplatform.net/' +
            brand +
            '_ghost.png'
        }
      }

      this.data.previewImage = image
      // console.log('🖼️ - file: product-config.html - line 160 - image', image)

      return image
    },
  }
}

function productConfig() {
  return {
    tag: '',
    builderUrl: '',
    hasProductConfig: false,
    data: null,
    status: 'loading',
    // existing_character_count: 1,
    init() {
      let moonshineConfig = JSON.parse(
        document.getElementById('moonshine_config_json').innerHTML
      )

      this.tag = moonshineConfig.character_config_key
      if (this.tag !== undefined) {
        this.hasProductConfig = true

        this.fetch(this.tag)
      }

      // this.existing_character_count = characterStorage.getAllCharacters()
      //   ? characterStorage.getAllCharacters().length
      //   : 1

      // // NOTE: added to know if we should show the load button
      // if(characterStorage && characterStorage.getAllCharacters()){
      //   console.log('🥰 product-config.js 199 character count:', characterStorage.getAllCharacters().length)
      // } else console.log('🥺 something is null')
    },
    fetch(tag) {
      // Fetch product config using the tag given and store it in window.store.productConfig
      // console.log(`product-config 185 - Fetching config for tag: ${tag}`)
      this.status = 'loading'
      fetch(
        `https://builder.midnightplatform.net/midnight/system/product_updates/index.php?tag=${tag}`
      )
        .then((res) => {
          if (!res.ok) {
            this.status = 'error'
          }
          return res.json()
        })
        .then((data) => {
          this.status = 'idle'
          this.data = data.success.characters

          // console.log('product-config 200 - ', data.success)

          // FIXME: TypeError: Cannot read properties of undefined (reading 'set') happens when page first loads sometimes
          window.store.set('productConfig', data.success)
          let contentWindow = document.getElementById('builder').contentWindow

          // Post config to builder
          contentWindow.postMessage(
            {
              event: 'config',
              value: data.success,
            },
            '*'
          )
        })
        .catch((error) => {
          this.status = 'error'
          console.log('Error with fetching tag: ', tag)
          console.log({
            error,
          })
        })
    },
  }
}
